module.exports = __webpack_public_path__ + "img/more-experirence-icon3.b36c86cf.png";